var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgSendScheduled = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5163 1.6665L8.34961 10.8332M17.5163 1.6665L0.849609 7.49984L8.34961 10.8332M17.5163 1.6665L15.3006 8.60851M8.34961 10.8332L9.18294 12.7082",
    stroke: "currentColor",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.778 18.3332C17.0302 18.3332 18.856 16.5074 18.856 14.2552C18.856 12.003 17.0302 10.1773 14.778 10.1773C12.5258 10.1773 10.7 12.003 10.7 14.2552C10.7 16.5074 12.5258 18.3332 14.778 18.3332Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7847 12.0439V14.4907L16.4159 15.3063",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSendScheduled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/send-scheduled.4ea7aa4b.svg";
export { ForwardRef as ReactComponent };